export default "__VITE_ASSET__4193144a__"